var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-menu g3" }, [
    _c("ul", [
      _c("li", { staticClass: "head" }, [_vm._v("Studies")]),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: _vm.createLink("active") } }, [
            _vm._v("Active"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: _vm.createLink("archived") } }, [
            _vm._v("Archived"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c(
            "router-link",
            { attrs: { to: _vm.createLink("study-aggregator") } },
            [_vm._v("Study Aggregator")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }